module.exports = __webpack_public_path__ + "img/move6.a32f5868.png";